
export default {
  definedAttributeList: [],
  variableList: [],
  variableTypes: [],
  variableValueTypes: []
}